'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var digiCert = function digiCert() {
    _classCallCheck(this, digiCert);

    return {
        loadCertificate: function loadCertificate() {
            var exist = document.getElementById('digi-seal');
            if (exist) {
                exist.remove();
            }
            var cid = document.createElement('script');
            cid.async = true;
            cid.id = 'digi-seal';
            cid.src = '//seal.digicert.com/seals/cascade/seal.min.js';
            var s = document.getElementsByTagName('script');
            var ls = s[s.length - 1];
            ls.parentNode.insertBefore(cid, ls.nextSibling);
        }
    };
};

exports.default = digiCert;


/** WEBPACK FOOTER **
 ** ./src/app/services/digiCert.js
 **/